import { TranslationsContext } from '@teliaee/telia-translate';
import React, { useContext } from 'react';
import { Separator } from 'telia-front-react';
import { Item } from './types';

interface MobileRoamingProps {
  item: Item;
}

const MobileRoaming: React.FC<MobileRoamingProps> = (props) => {
  const { translate } = useContext(TranslationsContext);
  const {
    item: { roaming }
  } = props;

  if (!roaming) {
    return null;
  }

  return (
    <React.Fragment>
      <p>
        {translate('packetItem.roaming')}
        <strong>{` ${roaming}`}</strong>
      </p>
      <Separator spacing="small" color="invisible" />
    </React.Fragment>
  );
};

export default MobileRoaming;
